import {SelectOption} from "react-select-material-ui";
import moment from "moment-timezone";

const getTimeZones = (): SelectOption[] => {
    let timeZones = moment.tz.names();
    let offsetTmz: SelectOption[] = [];
    for (let i in timeZones) {
        offsetTmz.push({
            label: `(GMT${moment.tz(timeZones[i]).format("Z")}) ${timeZones[i]}`,
            value: timeZones[i],
        });
    }
    return offsetTmz;
}

export default getTimeZones;